<template>
  <div class="admin-sidebar">
    <div class="row w-100">
      <div class="col-3 left-side scroll-style">
        <h3 class="show-hide-content">
          {{ $t("AdminDash") }}
        </h3>
        <a
          v-for="(item, index) in MyRoutes"
          :key="index"
          :href="item.link"
          class="sidebar-link"
          :class="{ active: $route.path === item.link }"
        >
          <span v-html="item.icon"></span>
          <span class="show-hide-content">
            {{ $i18n.locale === "ar" ? item.name_ar : item.name_en }}</span
          >
          <span class="mx-2" v-if="item.name_en == 'Messages'">{{
            $store.state.unread
          }}</span>
        </a>
      </div>
      <div class="col-9 right-side scroll-style"><slot></slot></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "admin-sidebar",
  data() {
    return {
      MyRoutes: [
        {
          name_ar: "معلومات الموقع",
          name_en: "Website Information",
          link: "/AdminHome",
          icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" style="margin-right:20px" viewBox="0 0 24 24"><path fill="currentColor" d="M12 0h-.029c-6.627 0-12 5.373-12 12s5.373 12 12 12H12c6.627 0 12-5.373 12-12S18.627 0 12 0m0 23.04h-.029C5.874 23.04.931 18.097.931 12S5.874.96 11.971.96H12C18.097.96 23.04 5.903 23.04 12S18.097 23.04 12 23.04" /><path fill="currentColor" d="M15.825 7.142c-.99.25-2.136.412-3.314.45l-.026.001v3.929h3.9a20 20 0 0 0-.589-4.516zM12.479 1.99v4.725a15.3 15.3 0 0 0 3.209-.437l-.105.022c-.756-2.39-1.933-3.958-3.104-4.31m-4.09 4.304c.926.232 2 .384 3.102.42l.025.001V1.979c-1.171.34-2.366 1.91-3.127 4.315m10.799-1.368A10.04 10.04 0 0 0 14.417 2.2l-.069-.014a9.8 9.8 0 0 1 2.064 3.813l.016.069a15 15 0 0 0 2.84-1.182zm-1.921 6.596h4.806a10 10 0 0 0-2.293-5.937l.013.017c-.89.502-1.923.948-3.005 1.285l-.115.031c.353 1.375.568 2.958.593 4.588zm-9.681 0h3.934V7.593a16.2 16.2 0 0 1-3.481-.48l.112.024a19 19 0 0 0-.565 4.37zm8.799.957h-3.906v3.92c1.204.035 2.353.197 3.457.474l-.11-.023c.332-1.305.534-2.808.559-4.354v-.016zm-8.233 4.379c1-.255 2.156-.42 3.345-.455l.024-.001v-3.92H7.586c.023 1.564.228 3.069.594 4.51zm3.37 5.158v-4.737c-1.13.037-2.205.188-3.24.443l.107-.022c.762 2.406 1.956 3.979 3.133 4.316m2.826-.202a10.13 10.13 0 0 0 4.845-2.745l.002-.002a14.6 14.6 0 0 0-2.65-1.113l-.108-.029a9.9 9.9 0 0 1-2.098 3.9zM9.617 2.198a10.1 10.1 0 0 0-4.804 2.733l-.002.002c.775.424 1.678.808 2.622 1.102l.107.029a9.9 9.9 0 0 1 2.086-3.876l-.01.011zm7.056 14.885c1.199.365 2.235.812 3.208 1.357l-.081-.042a9.96 9.96 0 0 0 2.278-5.897l.001-.023h-4.806a21 21 0 0 1-.631 4.75zm-4.194.196v4.73c1.171-.352 2.348-1.92 3.104-4.315a14.8 14.8 0 0 0-3.081-.415l-.023-.001zM7.304 6.911A15.8 15.8 0 0 1 4.126 5.56l.079.041a9.96 9.96 0 0 0-2.278 5.897l-.001.023h4.782c.023-1.647.239-3.233.626-4.751zm-.601 5.568H1.921c.107 2.266.95 4.316 2.293 5.937l-.013-.017c.883-.499 1.91-.943 2.984-1.279l.114-.031a20.3 20.3 0 0 1-.595-4.591v-.019zm-1.897 6.588a10.06 10.06 0 0 0 4.742 2.72l.069.015A9.8 9.8 0 0 1 7.554 18l-.017-.07a15.5 15.5 0 0 0-2.814 1.178z" /></svg>',
        },
        {
          name_ar: "الفريق",
          name_en: "Team",
          link: "/TeamView",
          icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" style="margin-right:20px" viewBox="0 0 20 20"><path fill="currentColor" d="M12.5 4.5a2.5 2.5 0 1 1-5 0a2.5 2.5 0 0 1 5 0m5 .5a2 2 0 1 1-4 0a2 2 0 0 1 4 0m-13 2a2 2 0 1 0 0-4a2 2 0 0 0 0 4M6 9.25C6 8.56 6.56 8 7.25 8h5.5c.69 0 1.25.56 1.25 1.25V14a4 4 0 0 1-8 0zm-1 0c0-.463.14-.892.379-1.25H3.25C2.56 8 2 8.56 2 9.25V13a3 3 0 0 0 3.404 2.973A5 5 0 0 1 5 14zM15 14c0 .7-.144 1.368-.404 1.973Q14.794 16 15 16a3 3 0 0 0 3-3V9.25C18 8.56 17.44 8 16.75 8h-2.129c.24.358.379.787.379 1.25z" /></svg>',
        },
        {
          name_ar: "لم نحن",
          name_en: "Why us",
          link: "/AdminServicesView",
          icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" style="margin-right:20px" viewBox="0 0 32 32"><path fill="currentColor" d="M21.5 2.5v1.406a5.6 5.6 0 0 0-2.28.938l-1.032-.97l-1.375 1.47l1 .937a5.7 5.7 0 0 0-.907 2.22H15.5v2h1.406c.146.83.474 1.586.938 2.25l-1.063 1.03l1.44 1.44l1.03-1.064c.664.464 1.42.792 2.25.938V16.5h2v-1.406a5.7 5.7 0 0 0 2.22-.906l.936 1l1.47-1.376l-.97-1.03c.47-.67.79-1.445.938-2.282H29.5v-2h-1.406a5.6 5.6 0 0 0-.938-2.25l.938-.938l-1.407-1.406l-.937.938a5.6 5.6 0 0 0-2.25-.938V2.5zm1 3.313A3.664 3.664 0 0 1 26.188 9.5c0 2.055-1.633 3.688-3.688 3.688s-3.688-1.633-3.688-3.688s1.633-3.688 3.688-3.688zM9.53 11.718l-1.842.75l.718 1.81a6.94 6.94 0 0 0-2.344 2.314l-1.78-.72l-.75 1.845l1.78.718a6.8 6.8 0 0 0-.218 1.656c0 .57.085 1.126.218 1.656l-1.78.72l.75 1.843l1.78-.72a6.9 6.9 0 0 0 2.344 2.345l-.72 1.78l1.845.75l.72-1.78a6.8 6.8 0 0 0 1.656.218c.57 0 1.128-.085 1.656-.218l.72 1.78l1.843-.75l-.72-1.78a6.9 6.9 0 0 0 2.314-2.344l1.81.718l.75-1.843l-1.81-.72c.13-.53.218-1.087.218-1.656c0-.57-.087-1.128-.22-1.657l1.813-.718l-.75-1.845l-1.81.72a6.9 6.9 0 0 0-2.314-2.314l.72-1.81l-1.845-.75l-.717 1.81a7 7 0 0 0-1.657-.217c-.57 0-1.126.086-1.656.218l-.72-1.81zm2.376 3.592c2.663 0 4.78 2.12 4.78 4.782c.002 2.663-2.117 4.812-4.78 4.812a4.806 4.806 0 0 1-4.812-4.812c0-2.663 2.15-4.782 4.812-4.782" /></svg>',
        },
        {
          name_ar: "من نمثلهم",
          name_en: "Who we present",
          link: "/PartnersView",
          icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" style="margin-right:20px" viewBox="0 0 512 512"><path fill="currentColor" d="M250.882 22.802c-23.366 3.035-44.553 30.444-44.553 65.935c0 19.558 6.771 36.856 16.695 48.815l11.84 14.263l-18.217 3.424c-12.9 2.425-22.358 9.24-30.443 20.336c-8.085 11.097-14.266 26.558-18.598 44.375c-7.843 32.28-9.568 71.693-9.842 106.436h42.868l11.771 157.836c29.894 6.748 61.811 6.51 90.602.025l10.414-157.86h40.816c-.027-35.169-.477-75.126-7.584-107.65c-3.918-17.934-9.858-33.372-18.04-44.343c-8.185-10.97-18.08-17.745-32.563-19.989l-18.592-2.88l11.736-14.704c9.495-11.897 15.932-28.997 15.932-48.082c0-37.838-23.655-65.844-49.399-65.844z" /></svg>',
        },
        {
          name_ar: "شركائنا",
          name_en: "Our Partners",
          link: "/OurPartnersView",
          icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" style="margin-right:20px" viewBox="0 0 512 512"><path fill="currentColor" d="M250.882 22.802c-23.366 3.035-44.553 30.444-44.553 65.935c0 19.558 6.771 36.856 16.695 48.815l11.84 14.263l-18.217 3.424c-12.9 2.425-22.358 9.24-30.443 20.336c-8.085 11.097-14.266 26.558-18.598 44.375c-7.843 32.28-9.568 71.693-9.842 106.436h42.868l11.771 157.836c29.894 6.748 61.811 6.51 90.602.025l10.414-157.86h40.816c-.027-35.169-.477-75.126-7.584-107.65c-3.918-17.934-9.858-33.372-18.04-44.343c-8.185-10.97-18.08-17.745-32.563-19.989l-18.592-2.88l11.736-14.704c9.495-11.897 15.932-28.997 15.932-48.082c0-37.838-23.655-65.844-49.399-65.844z" /></svg>',
        },
        {
          name_ar: "الأخبار",
          name_en: "News",
          link: "/NewsView",
          icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" style="margin-right:20px" viewBox="0 0 20 20"><path fill="currentColor" d="M5 12v-2h2v2zm10-7.506A1.5 1.5 0 0 0 13.5 3H3.423a1.5 1.5 0 0 0-1.5 1.5v9a2.5 2.5 0 0 0 2.5 2.5h11.154a2.5 2.5 0 0 0 2.5-2.5v-6a1.5 1.5 0 0 0-1.5-1.5H16v7.23a.5.5 0 0 1-1 0zM4 6.5a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 0 1h-8a.5.5 0 0 1-.5-.5M9.5 9h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1M9 12.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M4.5 9h3a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5" /></svg>',
        },
        {
          name_ar: "قصص النجاح",
          name_en: "Success Stories",
          link: "/StoriesView",
          icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" style="margin-right:20px" viewBox="0 0 20 20"><path fill="currentColor" d="M5 12v-2h2v2zm10-7.506A1.5 1.5 0 0 0 13.5 3H3.423a1.5 1.5 0 0 0-1.5 1.5v9a2.5 2.5 0 0 0 2.5 2.5h11.154a2.5 2.5 0 0 0 2.5-2.5v-6a1.5 1.5 0 0 0-1.5-1.5H16v7.23a.5.5 0 0 1-1 0zM4 6.5a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 0 1h-8a.5.5 0 0 1-.5-.5M9.5 9h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1M9 12.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M4.5 9h3a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5" /></svg>',
        },
        {
          name_ar: "الخدمات",
          name_en: "Services",
          link: "/ProductsView",
          icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" style="margin-right:20px" viewBox="0 0 2048 2048"><path fill="currentColor" d="m1344 2l704 352v785l-128-64V497l-512 256v258l-128 64V753L768 497v227l-128-64V354zm0 640l177-89l-463-265l-211 106zm315-157l182-91l-497-249l-149 75zm-507 654l-128 64v-1l-384 192v455l384-193v144l-448 224L0 1735v-676l576-288l576 288zm-640 710v-455l-384-192v454zm64-566l369-184l-369-185l-369 185zm576-1l448-224l448 224v527l-448 224l-448-224zm384 576v-305l-256-128v305zm384-128v-305l-256 128v305zm-320-288l241-121l-241-120l-241 120z" /></svg>',
        },
        {
          name_ar: "نكسس ليب في أرقام",
          name_en: "Nexus Leap in Numbers",
          link: "/CompanyNumbersView",
          icon: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24"><g fill="none" fill-rule="evenodd"><path d="m12.594 23.258l-.012.002l-.071.035l-.02.004l-.014-.004l-.071-.036q-.016-.004-.024.006l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.016-.018m.264-.113l-.014.002l-.184.093l-.01.01l-.003.011l.018.43l.005.012l.008.008l.201.092q.019.005.029-.008l.004-.014l-.034-.614q-.005-.019-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.003-.011l.018-.43l-.003-.012l-.01-.01z" /><path fill="currentColor" d="M4.5 5.5a3.5 3.5 0 0 1 6.995-.192l.005.202c0 1.922-.799 3.472-1.53 4.494a10 10 0 0 1-.76.931l-.26.27a6 6 0 0 1-.516.469a1.5 1.5 0 0 1-1.988-2.241l.222-.197l.124-.117l.157-.159l.088-.094A3.5 3.5 0 0 1 4.5 5.5M8 5a.5.5 0 1 0 0 1a.5.5 0 0 0 0-1m10.06-1.06a1.5 1.5 0 0 0-2.12 0l-2.83 2.827a1.5 1.5 0 1 0 2.121 2.121l.268-.268V20a1.5 1.5 0 1 0 3 0V8.621l.268.268a1.5 1.5 0 1 0 2.121-2.121zM4.5 16.5a3.5 3.5 0 1 1 7 0v2a3.5 3.5 0 1 1-7 0zM8 16a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-2A.5.5 0 0 0 8 16" /></g></svg>',
        },
        {
          name_ar: "تسجيل الخروج",
          name_en: "Logout",
          link: "/",
          icon: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24"><path fill="currentColor" d="M5 21q-.825 0-1.412-.587T3 19V5q0-.825.588-1.412T5 3h7v2H5v14h7v2zm11-4l-1.375-1.45l2.55-2.55H9v-2h8.175l-2.55-2.55L16 7l5 5z" /></svg>',
        },
        // {
        //   name_ar: "الرسائل",
        //   name_en: "Messages",
        //   link: "/messages",
        //   icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" style="margin-right:20px" viewBox="0 0 24 24"><g fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"><path d="M4 3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h1v2a1 1 0 0 0 1.707.707L9.414 13H15a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1z" /><path d="M8.023 17.215q.05-.046.098-.094L10.243 15H15a3 3 0 0 0 3-3V8h2a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-1v2a1 1 0 0 1-1.707.707L14.586 18H9a1 1 0 0 1-.977-.785" /></g></svg>',
        // },
      ],
    };
  },
  mounted() {
    const token = window.sessionStorage.getItem("token");
    const user_type = window.sessionStorage.getItem("user_type");
    if (!token) {
      // Use Vuex actions to set the values
      this.$store.user_type = user_type;
      this.$store.token = token;
      this.$router.push("/login");
    } else if (user_type !== "admin") {
      this.$router.push("/");
    }
  },
};
</script>

<style>
.scroll-style {
  --sb-track-color: var(--color-default);
  --sb-thumb-color: var(--color-primary);
  --sb-size: 6px;
}

.scroll-style::-webkit-scrollbar {
  width: var(--sb-size);
}

.scroll-style::-webkit-scrollbar-track {
  background: var(--sb-track-color);
  border-radius: 16px;
}

.scroll-style::-webkit-scrollbar-thumb {
  background: var(--sb-thumb-color);
  border-radius: 16px;
  border: 1px solid #232e33;
}

@supports not selector(::-webkit-scrollbar) {
  .scroll-style {
    scrollbar-color: var(--sb-thumb-color) var(--sb-track-color);
  }
}

.left-side {
  background-color: var(--color-primary);
  height: 100dvh;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
}
.right-side {
  height: 100dvh;
  overflow-y: scroll;
}

.sidebar-link {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 300px;
  padding: 10px 15px;
  margin: 5px 0;
  color: white;
  text-decoration: none;
  transition: background-color 0.3s ease, color 0.3s ease;
  border-radius: 8px;
}

.sidebar-link:hover {
  background-color: #fff;
  color: var(--color-default);
}

.sidebar-link.active {
  background-color: white;
  color: var(--color-default);
  font-weight: bold;
}

.link-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media screen and (max-width: 1300px) {
  .show-hide-content {
    display: none;
  }
  .sidebar-link {
    width: fit-content;
  }
}

.Error {
  color: crimson;
  font-size: 12px;
  font-weight: 600;
}
/* From Uiverse.io by Yaya12085 */
.form {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  gap: 10px;
  background-color: #fff;
  padding: 20px;
  border-radius: 20px;
  position: relative;
}

.title {
  font-size: 28px;
  color: var(--color-primary);
  font-weight: 600;
  letter-spacing: -1px;
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding-left: 30px;
}

.title::before,
.title::after {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  border-radius: 50%;
  left: 0px;
  background-color: var(--color-primary);
}

.title::before {
  width: 18px;
  height: 18px;
  background-color: var(--color-primary);
}

.title::after {
  width: 18px;
  height: 18px;
  -webkit-animation: pulse 1s linear infinite;
  animation: pulse 1s linear infinite;
}

.message,
.signin {
  color: rgba(88, 87, 87, 0.822);
  font-size: 14px;
}

.signin {
  text-align: center;
}

.flex {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: 100%;
  gap: 6px;
  flex-wrap: wrap;
}

.w-49 {
  width: 49%;
}

@media screen and (max-width: 900px) {
  .w-49 {
    width: 100%;
  }
}

.form label {
  position: relative;
}

.form label .input {
  width: 100%;
  padding: 10px 10px 20px 10px;
  outline: 0;
  border: 1px solid rgba(105, 105, 105, 0.397);
  border-radius: 10px;
}

.form label .input + span {
  position: absolute;
  top: 15px;
  color: grey;
  font-size: 0.9em;
  cursor: text;
  -webkit-transition: 0.3s ease;
  transition: 0.3s ease;
}

.form label .input:-moz-placeholder-shown + span {
  top: 15px;
  font-size: 0.9em;
}

.form label .input:-ms-input-placeholder + span {
  top: 15px;
  font-size: 0.9em;
}

.form label .input:placeholder-shown + span {
  top: 15px;
  font-size: 0.9em;
}

.form label .input:focus + span,
.form label .input:valid + span {
  top: 30px;
  font-size: 0.7em;
  font-weight: 600;
}

.form label .input:valid + span {
  color: var(--color-primary);
}

.submit {
  border: none;
  outline: none;
  background-color: var(--color-primary);
  padding: 10px;
  border-radius: 10px;
  color: #fff;
  font-size: 16px;
  -webkit-transition: 0.3s ease;
  -ms-transition: 0.3s ease;
  transition: 0.3s ease;
}

@-webkit-keyframes pulse {
  from {
    -webkit-transform: scale(0.9);
    transform: scale(0.9);
    opacity: 1;
  }

  to {
    -webkit-transform: scale(1.8);
    transform: scale(1.8);
    opacity: 0;
  }
}

@keyframes pulse {
  from {
    -webkit-transform: scale(0.9);
    transform: scale(0.9);
    opacity: 1;
  }

  to {
    -webkit-transform: scale(1.8);
    transform: scale(1.8);
    opacity: 0;
  }
}

/* From Uiverse.io by Yaya12085 */
.custum-file-upload {
  height: 200px;
  width: 300px;
  display: flex;
  flex-direction: column;
  align-items: space-between;
  gap: 20px;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  border: 2px dashed #cacaca;
  background-color: rgba(255, 255, 255, 1);
  padding: 1.5rem;
  border-radius: 10px;
  box-shadow: 0px 48px 35px -48px rgba(0, 0, 0, 0.1);
}

.custum-file-upload .icon {
  display: flex;
  align-items: center;
  justify-content: center;
}

.custum-file-upload .icon svg {
  height: 80px;
  fill: rgba(75, 85, 99, 1);
}

.custum-file-upload .text {
  display: flex;
  align-items: center;
  justify-content: center;
}

.custum-file-upload .text span {
  font-weight: 400;
  color: rgba(75, 85, 99, 1);
}

.custum-file-upload input {
  display: none;
}
</style>
